// extracted by mini-css-extract-plugin
export var sliderRange = "_p4-2";
export var sliderRoot = "_p4-0";
export var sliderThumb = "_p4-3";
export var sliderTrack = "_p4-1";